import { useNavigate } from 'react-router';

import PosTerminalIcon from '~domains/partner-application/shared/assets/icons/pos-terminal.svg?react';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ampli } from '~entities/ampli';

import { ROUTES } from '~shared/config/routes';
import { Screen } from '~shared/ui/screen';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

export const NoApplicationScreen = () => {
  const navigate = useNavigate();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<PosTerminalIcon />}
        title={
          <>
            Tell&nbsp;us about your&nbsp;business,{' '}
            <span className="text-skyro-blue">boss!</span>
          </>
        }
        description={
          <>
            Share the&nbsp;main&nbsp;details to&nbsp;get
            your&nbsp;account&nbsp;ready.
          </>
        }
        action={{
          label: 'Start application',
          onClick: () => {
            ampli.mpPaStartApplicationClick();
            navigate(ROUTES.partner.application);
          },
        }}
      />
    </Screen>
  );
};
